export default function (userRolesObject) {
    return {
        items: [
            {
                text: 'Tasks',
                uiSref: 'tasks',
                highlightWhenChildOf: 'tasks',
                roles: [userRolesObject.admin, userRolesObject.operator, userRolesObject.teamLead]
            },
            {
                text: 'Letters/Comms',
                uiSref: 'letters.list',
                highlightWhenChildOf: 'letters',
                roles: [userRolesObject.admin, userRolesObject.operator, userRolesObject.teamLead, userRolesObject.rrd]
            },
            {
                text: 'Enquiries &amp; Vehicles',
                uiSref: 'enquiries.list',
                highlightWhenChildOf: 'enquiries',
                roles: [userRolesObject.admin, userRolesObject.operator, userRolesObject.teamLead]
            },
            {
                text: 'Data Import/Export',
                uiSref: 'data-import-export.import.list',
                highlightWhenChildOf: 'data-import-export.import',
                roles: [userRolesObject.admin, userRolesObject.operator, userRolesObject.teamLead, userRolesObject.rrd]
            },
            {
                text: 'MI Reports',
                uiSref: 'mireports.details ({ reportName: \'operationalAudit\' })',
                highlightWhenChildOf: 'mireports.details',
                roles: [userRolesObject.admin, userRolesObject.teamLead]
            },
            {
                text: 'Dealers',
                uiSref: 'dealers.list',
                highlightWhenChildOf: 'dealers',
                roles: [userRolesObject.admin, userRolesObject.operator, userRolesObject.teamLead, userRolesObject.accountAdmin]
            },
            {
                text: 'Users',
                uiSref: 'users.list',
                highlightWhenChildOf: 'users',
                roles: [userRolesObject.admin, userRolesObject.operator, userRolesObject.teamLead]
            }
        ]
    };
}



// WEBPACK FOOTER //
// ./Client/app/common/services/topMenuOptions.js